import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlagLt = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "27px",
	height: "18px",
	viewBox: "0 0 27 18",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title === undefined ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: "D491B859-85A0-4E45-9977-1CAC7017DC13"
	}) : title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "UI",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Registruokit\\u0117s-vizitui",
			transform: "translate(-735.000000, -531.000000)",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Group-11",
				transform: "translate(515.000000, 531.000000)",
				children: /* @__PURE__ */ _jsxs("g", {
					id: "LT_flag-Copy-3",
					transform: "translate(220.000000, 0.000000)",
					children: [
						/* @__PURE__ */ _jsx("path", {
							d: "M2,0 L25,0 C26.1045695,-2.02906125e-16 27,0.8954305 27,2 L27,6 L27,6 L0,6 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 Z",
							id: "Rectangle",
							fill: "#FDB913"
						}),
						/* @__PURE__ */ _jsx("rect", {
							id: "Rectangle-Copy",
							fill: "#006A44",
							x: 0,
							y: 6,
							width: 27,
							height: 6
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M0,12 L27,12 L27,16 C27,17.1045695 26.1045695,18 25,18 L2,18 C0.8954305,18 1.3527075e-16,17.1045695 0,16 L0,12 L0,12 Z",
							id: "Rectangle-Copy-2",
							fill: "#C1272D"
						})
					]
				})
			})
		})
	})]
});
const ForwardRef = forwardRef(SvgFlagLt);
export default ForwardRef;
